<template>
    <WorkScheduleContainerRow class="titleRow"><span>{{ title.title }}</span></WorkScheduleContainerRow>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {Title} from '@cquential/api';
    import WorkScheduleContainerRow from '@/components/WorkSchedule/WorkScheduleContainerRow.vue';

    @Component({
        components: {
            WorkScheduleContainerRow,
        },
    })
    export default class TitleRow extends Vue {
        @Prop({required: true}) public title!: Title;
    }
</script>

<style lang="scss" scoped>
    .titleRow {
        /**
         * 1.25rem * 3 - height of content
         * 0.2rem * 6 - padding of the cells (0.2rem * (top + bottom * 2))
         * 4px - extra padding from bottommost cell
         * 1px * 4 - borders of the cell
         */
        --top-offset: calc((1.25rem * 3) + (var(--cell-padding) * 6) + 4px + 4px);
        /**
         * When the resulting pixel ends up with .5 or higher it will be one pixel too far. So round down.
         */
        top: round(down, var(--top-offset), 1px);
        position: sticky;
        z-index: 2;
        grid-column: 1 / -1;
        border-bottom: 1px solid var(--work-schedule-border-color);
        font-weight: bold;
        background: var(--modal-background);

        span {
            position: sticky;
            left: var(--cell-padding);
        }
    }
</style>
